import { whatsappService } from "@/_services";

export const whatsapp = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    entity: {
      data: [],
      status: {},
    },
    detail: {
      data: [],
      status: {},
    },
    webhookLog: {
      data: [],
      status: {},
    },
    sendLog: {
      data: [],
      status: {},
    },
    resumen: {
      data: [],
      status: {},
    },
    excel: {
      data: null,
      status: {},
    },
  },
  mutations: {
    getWhatsappChatsRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getWhatsappChatsSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getWhatsappChatsError(state, error) {
      state.list.data = [];
      state.list.status = {
        error,
      };
    },
    getWhatsappChatsByEntityIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getWhatsappChatsByEntityIdSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
    getWhatsappChatsByEntityIdError(state, error) {
      state.entity.data = [];
      state.entity.status = {
        error,
      };
    },
    getWhatsappChatByIdRequest(state) {
      state.detail.status = {
        loading: true,
      };
    },
    getWhatsappChatByIdSuccess(state, response) {
      state.detail.data = response;
      state.detail.status = {
        loaded: true,
      };
    },
    getWhatsappChatByIdError(state, error) {
      state.detail.data = null;
      state.detail.status = {
        error,
      };
    },
    getWhatsappWebhookLogByIdRequest(state) {
      state.webhookLog.status = {
        loading: true,
      };
    },
    getWhatsappWebhookLogByIdSuccess(state, response) {
      state.webhookLog.data = response;
      state.webhookLog.status = {
        loaded: true,
      };
    },
    getWhatsappWebhookLogByIdError(state, error) {
      state.webhookLog.data = [];
      state.webhookLog.status = {
        error,
      };
    },
    getWhatsappSendLogByIdRequest(state) {
      state.sendLog.status = {
        loading: true,
      };
    },
    getWhatsappSendLogByIdSuccess(state, response) {
      state.sendLog.data = response;
      state.sendLog.status = {
        loaded: true,
      };
    },
    getWhatsappSendLogByIdError(state, error) {
      state.sendLog.data = [];
      state.sendLog.status = {
        error,
      };
    },
    getWhatsappResumenRequest(state) {
      state.resumen.status = {
        loading: true,
      };
    },
    getWhatsappResumenSuccess(state, response) {
      state.resumen.data = response;
      state.resumen.status = {
        loaded: true,
      };
    },
    getWhatsappResumenError(state, error) {
      state.resumen.data = [];
      state.resumen.status = {
        error,
      };
    },
    getWhatsappChatsAsExcelRequest(state) {
      state.excel.status = {
        loading: true,
      };
    },
    getWhatsappChatsAsExcelSuccess(state, response) {
      state.excel.data = response;
      state.excel.status = {
        loaded: true,
      };
    },
    getWhatsappChatsAsExcelError(state, error) {
      state.excel.data = null;
      state.excel.status = {
        error,
      };
    },
  },
  actions: {
    getWhatsappChats({ commit }, request) {
      commit("getWhatsappChatsRequest");
      return whatsappService
        .getWhatsappChats(request.pagination, request.filters)
        .then((response) => {
          commit("getWhatsappChatsSuccess", response);
          return response;
        })
        .catch((error) => {
          commit("getWhatsappChatsError", error);
          throw error;
        });
    },
    getWhatsappChatsByEntityId({ commit }, entityId) {
      commit("getWhatsappChatsByEntityIdRequest");
      return whatsappService
        .getWhatsappChatsByEntityId(entityId)
        .then((response) => {
          commit("getWhatsappChatsByEntityIdSuccess", response);
          return response;
        })
        .catch((error) => {
          commit("getWhatsappChatsByEntityIdError", error);
          throw error;
        });
    },
    getWhatsappChatById({ commit }, id) {
      commit("getWhatsappChatByIdRequest");
      return whatsappService
        .getWhatsappChatById(id)
        .then((response) => {
          commit("getWhatsappChatByIdSuccess", response);
          return response;
        })
        .catch((error) => {
          commit("getWhatsappChatByIdError", error);
          throw error;
        });
    },
    getWhatsappWebhookLogById({ commit }, logId) {
      commit("getWhatsappWebhookLogByIdRequest");
      return whatsappService
        .getWhatsappWebhookLogById(logId)
        .then((response) => {
          commit("getWhatsappWebhookLogByIdSuccess", response);
          return response;
        })
        .catch((error) => {
          commit("getWhatsappWebhookLogByIdError", error);
          throw error;
        });
    },
    getWhatsappSendLogById({ commit }, logId) {
      commit("getWhatsappSendLogByIdRequest");
      return whatsappService
        .getWhatsappSendLogById(logId)
        .then((response) => {
          commit("getWhatsappSendLogByIdSuccess", response);
          return response;
        })
        .catch((error) => {
          commit("getWhatsappSendLogByIdError", error);
          throw error;
        });
    },
    getWhatsappResumen({ commit }, filters) {
      commit("getWhatsappResumenRequest");
      return whatsappService
        .getWhatsappResumen(filters)
        .then((response) => {
          commit("getWhatsappResumenSuccess", response);
          return response;
        })
        .catch((error) => {
          commit("getWhatsappResumenError", error);
          throw error;
        });
    },
    getWhatsappChatsAsExcel({ commit }, filters) {
      commit("getWhatsappChatsAsExcelRequest");
      return whatsappService
        .getWhatsappChatsAsExcel(filters)
        .then((response) => {
          commit("getWhatsappChatsAsExcelSuccess", response);
          return response;
        })
        .catch((error) => {
          commit("getWhatsappChatsAsExcelError", error);
          throw error;
        });
    },
  },
};
